export enum PollyLanguage {
  ARABIC = 'arb',
  CHINESE = 'cn',
  CZECH = 'cz',
  DANISH = 'dk',
  DUTCH = 'nl',
  ENGLISH = 'en',
  FINNISH = 'fi',
  FRENCH = 'fr',
  GERMAN = 'de',
  HINDI = 'in',
  ICELANDIC = 'is',
  ITALIAN = 'it',
  JAPANESE = 'jp',
  KOREAN = 'kr',
  NORWEGIAN = 'no',
  POLISH = 'pl',
  PORTUGUESE = 'pt',
  ROMANIAN = 'ro',
  RUSSIAN = 'ru',
  SPANISH = 'es',
  SWEDISH = 'se',
  TURKISH = 'tr',
  WELSH = 'gb',
}

export enum PollyEngine {
  NEURAL = 'neural',
  STANDARD = 'standard',
  LONG_FORM = 'long-form',
  GENERATIVE = 'generative',
}

export const POLLY_LANGUAGE_LABELS: Record<PollyLanguage, string> = {
  [PollyLanguage.ARABIC]: 'Arabic',
  [PollyLanguage.CHINESE]: 'Chinese',
  [PollyLanguage.CZECH]: 'Czech',
  [PollyLanguage.DANISH]: 'Danish',
  [PollyLanguage.DUTCH]: 'Dutch',
  [PollyLanguage.ENGLISH]: 'English',
  [PollyLanguage.FINNISH]: 'Finnish',
  [PollyLanguage.FRENCH]: 'French',
  [PollyLanguage.GERMAN]: 'German',
  [PollyLanguage.HINDI]: 'Hindi',
  [PollyLanguage.ICELANDIC]: 'Icelandic',
  [PollyLanguage.ITALIAN]: 'Italian',
  [PollyLanguage.JAPANESE]: 'Japanese',
  [PollyLanguage.KOREAN]: 'Korean',
  [PollyLanguage.NORWEGIAN]: 'Norwegian',
  [PollyLanguage.POLISH]: 'Polish',
  [PollyLanguage.PORTUGUESE]: 'Portuguese',
  [PollyLanguage.ROMANIAN]: 'Romanian',
  [PollyLanguage.RUSSIAN]: 'Russian',
  [PollyLanguage.SPANISH]: 'Spanish',
  [PollyLanguage.SWEDISH]: 'Swedish',
  [PollyLanguage.TURKISH]: 'Turkish',
  [PollyLanguage.WELSH]: 'Welsh',
};

export const DEFAULT_ENGINE = PollyEngine.GENERATIVE;
export const DEFAULT_VOICE_ID = 'Ruth';
